import { boolean, Infer, optional, string, type } from "superstruct";
import { getFirebaseFunctionDefinition } from "../../utils/getFirebaseFunctionDefinition";

const GetWebhookConfigRequestStruct = type({
  /**
   * Organization ID to get webhook config for.
   */
  organizationId: string(),
});

const GetWebhookConfigResponseStruct = type({
  /**
   * The webhook config ID.
   */
  webhookConfigId: optional(string()),
  /**
   * The configured webhook URL.
   */
  url: optional(string()),
  /**
   * The bearer token provided by the customer.
   */
  bearerToken: optional(string()),
  /**
   * Whether the webhook is enabled.
   */
  enabled: optional(boolean()),
});

export type GetWebhookConfigRequest = Infer<
  typeof GetWebhookConfigRequestStruct
>;
export type GetWebhookConfigResponse = Infer<
  typeof GetWebhookConfigResponseStruct
>;

export const getWebhookConfigDefinition = getFirebaseFunctionDefinition({
  path: "/webhooks/get-config",
  reqType: GetWebhookConfigRequestStruct,
  resType: GetWebhookConfigResponseStruct,
});
